export default "__VITE_ASSET__ClUPwrkd__"